import type { ImgHTMLAttributes } from "react";

import craniometrixMarkOrangeUrl from "../assets/craniometrix-mark-orange.png";
import { COMPANY_NAME } from "../branding";
import { cn } from "../lib/utils";

type CraniometrixMarkProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "alt" | "src"> & {
  alt?: string;
};

export function CraniometrixMark({
  alt = COMPANY_NAME,
  className,
  ...props
}: CraniometrixMarkProps) {
  return (
    <img
      {...props}
      alt={alt}
      src={craniometrixMarkOrangeUrl}
      className={cn("h-8 w-auto select-none", className)}
      draggable={false}
    />
  );
}
